import type { StepType } from '@reactour/tour';
import type { TourStepContext } from './types';

export const reportsSteps = (_ctx: TourStepContext): StepType[] => [
  {
    selector: '[data-tour="reports-tabs"]',
    content:
      'Os Relatórios estão organizados em três visões: Executiva (KPIs e gráficos), Financeira (orçamentos) e Portfólio (tabela consolidada de todos os projetos).',
  },
  {
    selector: '[data-tour="reports-tab-executive"]',
    content:
      'A visão Executiva traz gráficos de tendência dos principais KPIs do portfólio — ideal para apresentações e reuniões de governança.',
  },
  {
    selector: '[data-tour="reports-tab-financial"]',
    content:
      'A visão Financeira consolida orçamentos aprovados, realizados e desvios por projeto. Útil para gestão de custos.',
  },
  {
    selector: '[data-tour="reports-tab-portfolio"]',
    content:
      'A visão Portfólio compara todos os projetos lado a lado com prazo, status, progresso e orçamento em uma única tabela exportável.',
  },
];
